module.exports = __webpack_public_path__ + "img/delete-point.084b9026.svg";